module.exports = __webpack_public_path__ + "static/media/Waves.25772f85.ogg";